<template>
  <div>
    <v-container
      :class="$vuetify.breakpoint.xlOnly ? 'container-mypad' : ''"
      v-if="!loading"
      style="padding: 8px"
    >
      <v-card class="ma-0 pa-0" flat :loading="loading">
        <v-row>
          <v-col xl="3" lg="3" md="3" sm="12" xs="12">
            <div align="center" :class="$vuetify.breakpoint.mdAndUp ? 'pa-5' :'pt-5'">
              <Avatar
                v-if="user.avatar != null"
                align="center"
                justify="center"
                class="user-avatar"
                :src="`https://tradeinpool.com/upload/${user.avatar}.png`"
                :size="160"
              ></Avatar>
              <Avatar v-else class="user-avatar" :username="user.username" :size="160"></Avatar>
            </div>
          </v-col>

          <v-col xl="9" lg="9" md="9" sm="12" xs="12">
            <div
              :align="$vuetify.breakpoint.mdAndUp ? 'left' :'center'"
              :class="$vuetify.breakpoint.mdAndUp ? 'mt-4' :''"
            >
              <span class="stats-name">{{user.username}}</span>
              <v-chip color="primary" class="ml-2 mr-1 mb-3" label small>Founder</v-chip>
              <v-chip color="#4dbac0" class="ma-1 mb-4" label small>Expert</v-chip>

              <span v-if="$vuetify.breakpoint.mdAndUp">
                <v-btn
                  :disabled="myOwn"
                  color="primary"
                  class="float-right ma-1 mr-8"
                  rounded
                  small
                >Message</v-btn>
                <v-btn
                  @click="follow"
                  :disabled="myOwn"
                  color="success"
                  class="float-right ma-1"
                  rounded
                  outlined
                  small
                >{{followLabel}}</v-btn>
              </span>

              <div class>
                <v-chip color="#333B47" outlined label small>
                  <v-icon size="16" color="#808F9C" left>query_builder</v-icon>
                  <span class="text-grey">Last visit {{user.updatedAt}}</span>
                </v-chip>
                <v-chip class="ml-2" color="#333B47" outlined label small>
                  <v-icon size="16" color="#808F9C" left>how_to_reg</v-icon>
                  <span class="text-grey">Joined {{user.createdAt}}</span>
                </v-chip>
              </div>

              <div v-if="!$vuetify.breakpoint.mdAndUp" align="center" justify="center" class="mt-4">
                <v-btn color="primary" class="mx-1" rounded small>Message</v-btn>
                <v-btn
                  color="success"
                  :disabled="myOwn"
                  @click="follow"
                  class="mx-1"
                  rounded
                  outlined
                  small
                >{{followLabel}}</v-btn>
              </div>

              <div
                class="mt-4"
                :align="$vuetify.breakpoint.mdAndUp ? 'left' :'center'"
                :class="$vuetify.breakpoint.mdAndUp ? '' :'mb-2'"
              >
                <div class="my-card px-6 pb-1 pt-2 mb-2">
                  <span
                    class="stat-number"
                    :class="stats.successRate >= 20 ? 'successes': 'loss'"
                  >{{stats.successRate.toFixed(2)}}%</span>
                  <div class="stat-text">Return</div>
                </div>
                <div class="my-card px-6 pb-1 pt-2 ml-4 mb-4">
                  <span class="stat-number">{{user._followers.length}}</span>
                  <div class="stat-text">Followers</div>
                </div>
                <div class="my-card px-6 pb-1 pt-2 ml-4 mb-4">
                  <span class="stat-number">{{stats.tradesArr.length}}</span>
                  <div class="stat-text">Trades</div>
                </div>
                <div
                  @click="routeStrategies"
                  class="my-card px-6 pb-1 pt-2 ml-4 mb-4 hover pointer"
                >
                  <span class="stat-number">{{user._strategies.length}}</span>
                  <div class="stat-text">Strategies</div>
                </div>
                <div @click="routeTags" class="my-card px-6 pb-1 pt-2 ml-4 mb-4 hover pointer">
                  <span class="stat-number">{{user._tags.length}}</span>
                  <div class="stat-text">Tags</div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>

      <BigEquity :data="stats.tradesArr" />

      <v-row>
        <v-col xl="6" lg="6" md="12" sm="12" xs="12">
          <v-card class="mt-2" flat>
            <MiniSeven :data="stats.lastSeven" />
          </v-card>
        </v-col>

        <v-col xl="3" lg="3" md="12" sm="12" xs="12">
          <v-card class="mt-2" flat>
            <MiniWeek :data="stats.weekDays" />
          </v-card>
        </v-col>

        <v-col xl="3" lg="3" md="12" sm="12" xs="12">
          <v-card class="mt-2" flat>
            <MiniGauge :data="stats.successRate" />
          </v-card>
        </v-col>

        <v-col xl="6" lg="6" md="6" sm="12" xs="12">
          <v-card flat>
            <UserTimeline />
          </v-card>
        </v-col>

        <v-col xl="6" lg="6" md="6" sm="12" xs="12">
          <v-card flat>
            <UserFollowers />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <div class="width-full" style="text-align:center;margin-top: 120px" v-else>
      <v-progress-circular :size="100" :width="7" color="#4dbac0" indeterminate>
        <div class="text-center">
          <div>
            <img class="brand-img" width="50" src="https://tradeinpool.com/img/logo.svg" />
          </div>
          <div>loading...</div>
        </div>
      </v-progress-circular>
    </div>
  </div>
</template>

<script>
var moment = require("moment-timezone");
import { mapGetters } from "vuex";
import Avatar from "vue-avatar";
import BigEquity from "./bigEquity.vue";
import MiniSeven from "@/components/minicharts_v2/miniSeven.vue";
import MiniWeek from "@/components/minicharts_v2/miniWeek.vue";
import MiniGauge from "@/components/minicharts_v2/miniGauge.vue";
import UserTimeline from "./userTimeline.vue";
import UserFollowers from "./userFollowers.vue";

import axios from "axios";
export default {
  name: "UserDetail",

  components: {
    Avatar,
    MiniGauge,
    MiniWeek,
    MiniSeven,
    BigEquity,
    UserTimeline,
    UserFollowers
  },

  data() {
    return {
      followLabel: "Follow",
      following: false,
      myOwn: false,
      user: null,
      loading: true,
      tempName: this.$route.params.name,
      stats: {
        successRate: 0,
        weekDays: [0, 0, 0, 0, 0, 0, 0],
        lastSeven: [],
        equity: [],
        tradesArr: []
      }
    };
  },

  watch: {
    "$route.params.name"(val) {
      // call the method which loads your initial state
      this.tempName = val;
      this.getUser();
    }
  },

  created() {},

  mounted() {
    this.getUser();
  },

  computed: {
    ...mapGetters(["timezone", "username"])
  },

  methods: {
    routeStrategies() {
      return this.$router.push({
        name: "strategies",
        params: { name: this.$route.params.name }
      });
    },
    routeTags() {
      return this.$router.push({
        name: "tags",
        params: { name: this.$route.params.name }
      });
    },
    setInitData() {
      this.user.updatedAt = moment(this.user.updatedAt).fromNow();
      this.user.createdAt = moment(this.user.createdAt).fromNow();
    },
    getUser() {
      if (!this.$route.params.name) {
        this.tempName = this.username;
      }
      if (this.tempName == this.username) {
        this.myOwn = true;
      }
      axios
        .post("https://tradeinpool.com:3001/api/request/user/", {
          name: this.tempName
        })
        .then(response => {
          this.statsRecalc(response.data);
          setTimeout(() => {
            this.loading = false;
          }, 500);

          this.setInitData();
          if (!this.myOwn) this.getFollowing();
          this.$scrollTo("#app", 500, { easing: "ease-in" });
        });
    },
    getFollowing() {
      this.user._followers.forEach(follower => {
        if (follower.username == this.username) {
          this.following = true;
          this.followLabel = "Stop Following";
        }
      });
    },
    follow() {
      if (!this.myOwn) {
        var newVal = true;
        if (this.following) newVal = false;
        axios
          .post("https://tradeinpool.com:3001/api/update/user/", {
            method: "following",
            value: newVal,
            name: this.tempName
          })
          .then(response => {
            this.following = response.data;
            this.loading = false;
            if (response.data == true) this.followLabel = "Stop Following";
            else if (response.data == false) this.followLabel = "Follow";
            this.getUser();
            //if (!this.myOwn) this.getFollowing();
          });
      }
    },
    statsRecalc(data) {
      this.user = data;

      var profits = [];
      var losts = [];
      this.stats.successRate = 0;
      this.stats.tradesArr = data._trades;
      this.stats.weekDays = [0, 0, 0, 0, 0, 0, 0];
      this.stats.lastSeven = [];

      this.user._trades.forEach(trade => {
        if (trade.ClosedProfitLoss > 0) {
          profits.push(trade.ClosedProfitLoss);
        } else {
          losts.push(trade.ClosedProfitLoss);
        }
        this.stats.weekDays[new Date(trade.createdAt).getDay()] += 1;
      });

      if (this.user._trades.length > 0) {
        this.stats.successRate = parseFloat(
          (profits.length / (losts.length + profits.length)) * 100
        );
      }
      this.user._diary.forEach(day => {
        var dailyPL = 0;
        day._trades.forEach(trade => {
          dailyPL += trade.ClosedProfitLoss;
        });
        this.stats.lastSeven.unshift({
          createdAt: day.date,
          pl: dailyPL,
          date: day.dateString
        });
      });
    }
  }
};
</script>

<style scoped>
.arrow-back {
  top: 0px;
  position: absolute;
  left: -100px;
  padding-top: 5px;
  text-align: center;
  height: 60px;
  width: 60px;
  background-color: rgba(0, 0, 0, 0.3);
  transition: 0.5s;
  cursor: pointer;
}
.arrow-back-show {
  left: 0px;
}
.arrow-back:hover {
  text-align: left;
}
.title-move {
  margin-left: 60px;
}
.trans {
  transition: 0.5s;
}
.v-expansion-panels {
  background-color: white !important;
}

.myChip {
  float: left;
  background: #4dbac0 !important;
  width: auto;
  height: 34px;
  font-size: 24px;
  border-radius: 17px;
}

.min-flexheight {
  min-height: 250px;
}

.user-avatar {
  border: 2px solid #333b47;
  border-radius: 50%;
}

.stats-name {
  text-transform: uppercase;
  font-size: 28px;
  font-weight: bold;
}
</style>